export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            联系我们
          </h2>
          <p className="text-foreground-600 text-sm mb-10 leading-relaxed">
            欢迎安全研究者、白帽黑客和知情人士提供暗网相关线索，支持PGP加密通信保障信源安全。对于高质量独家线索，平台将根据新闻价值提供稿酬。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
            <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center group hover:border-primary-300 transition-colors cursor-pointer">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-4 text-primary-600 text-xl">
                <i className="ri-mail-send-line"></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">线索投稿</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                tips@51darkweb.com
              </p>
            </div>

            <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center group hover:border-primary-300 transition-colors cursor-pointer">
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-4 text-accent-600 text-xl">
                <i className="ri-chat-smile-2-line"></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                biz@51darkweb.com
              </p>
            </div>

            <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 text-center group hover:border-primary-300 transition-colors cursor-pointer">
              <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-4 text-secondary-600 text-xl">
                <i className="ri-shield-keyhole-line"></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-1">PGP加密</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">
                公钥索取请邮件联系
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}